export enum NavigationTab {
  Home = 1,
  ThirdParties = 2,
  Products = 3,
  Plans = 4,
  Contracts = 5,
  Vehicles = 6,
  Claims = 7,
  Workflows = 8,
  Chat = 9,
  Analytics = 10,
  Accounting = 11,
  Reporting = 12,
  Cessions = 13,
  Clients = 14,
  Queries = 15, // Note: JSON says 38, but conflicting with existing 15. Keeping 15 for now if used elsewhere, but adding alias if needed? 
  // Actually, let's assume the user provided JSON is the source for the NEW tabs. 
  // If Queries is 38 in the new system, I should probably add it.
  // But Validation with existing code: Queries used as 15. 
  // "Visible if user has Queries access". If the backend now returns 38 for Queries, I should update it to 38?
  // Or maybe "Queries" (15) is something else?
  // The JSON says "id": 38, "name": "Queries".
  // The enum says Queries = 15. The enum also has Information_Agent = 15.
  // This looks like a clash.
  
  Customers = 37,
  Queries_Tab = 38, // Using Queries_Tab to avoid conflict for now, or I should rename the old one?
  Settings = 39,
  ServiceAdvisors = 40,
  RepairFacilities = 41,
  Insurer = 42,
  LienHolders = 43,
  SalesPeople = 44,
  Vendors = 45,
  SnowflakeReports = 46,
  Management = 47,
  Sales = 48,
  Cancellations = 49,

  Information_Agent = 15,
  Dealerships_Agent = 16,
  Products_Agent = 17,
  Commissions_Agent = 18,
  Claims_Agent = 19,
  Contracts_Agent = 20,
}
